// extracted by mini-css-extract-plugin
export default {"grid":"SizeCheckbox_grid__NdMYC"};